import {
  Bar,
  BarChart,
  CartesianGrid,
  Cell,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";

import { formatUsd } from "@kontextwerk/web-common";

import type { CostSummaryBucket } from "../lib/types";

interface Props {
  buckets: CostSummaryBucket[];
  topN?: number;
  color?: string;
  height?: number;
}

const PALETTE = ["#7C5CFF", "#A78BFA", "#14B8A6", "#4DD0E1", "#FBBF24", "#5EEAD4"];

export default function TopNBarChart({
  buckets,
  topN = 10,
  color,
  height = 280,
}: Props) {
  const top = [...buckets]
    .sort((a, b) => b.total_cost_usd - a.total_cost_usd)
    .slice(0, topN);
  if (top.length === 0) {
    return (
      <div className="text-sm text-kw-text-faint py-8 text-center">
        Keine Buckets im gewählten Zeitraum.
      </div>
    );
  }
  return (
    <ResponsiveContainer width="100%" height={height}>
      <BarChart
        data={top}
        layout="vertical"
        margin={{ top: 8, right: 24, bottom: 8, left: 8 }}
      >
        <CartesianGrid strokeDasharray="3 3" stroke="#1E2547" />
        <XAxis
          type="number"
          tickFormatter={(v) => formatUsd(v)}
          tick={{ fontSize: 11, fill: "#94A3B8" }}
        />
        <YAxis
          type="category"
          dataKey="group_key"
          tick={{ fontSize: 11, fill: "#94A3B8" }}
          width={160}
        />
        <Tooltip
          contentStyle={{
            backgroundColor: "#141A38",
            border: "1px solid #2A3358",
            fontSize: "12px",
          }}
          formatter={(value: number) => formatUsd(value)}
        />
        <Bar dataKey="total_cost_usd">
          {top.map((_, idx) => (
            <Cell key={idx} fill={color ?? PALETTE[idx % PALETTE.length]} />
          ))}
        </Bar>
      </BarChart>
    </ResponsiveContainer>
  );
}
